// extracted by mini-css-extract-plugin
export default {"glass":"Profile_glass__d8GZw","profile_img":"Profile_profile_img__nIq7t","textbox":"Profile_textbox__A+ja7"};